var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89172 3.03906C12.2997 3.03906 13.5037 3.03906 14.2517 3.78713C14.9998 4.53519 14.9998 5.73918 14.9998 8.14717V9.84987C14.9998 12.2578 14.9998 13.4618 14.2517 14.2099C13.5037 14.958 12.2997 14.958 9.89172 14.958",
    stroke: "#007BFF",
    strokeWidth: 1.22973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 16.5664L7.99988 1.43127",
    stroke: "#007BFF",
    strokeWidth: 1.22973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10815 3.03906C3.70019 3.03906 2.49621 3.03906 1.74813 3.78713C1.00005 4.53519 1.00005 5.73918 1.00005 8.14717V9.84987C1.00005 12.2578 1.00005 13.4618 1.74813 14.2099C2.49621 14.958 3.70019 14.958 6.10815 14.958",
    stroke: "#007BFF",
    strokeWidth: 1.22973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitB);
export default __webpack_public_path__ + "static/media/split-b.c51e16c0819e50c416f05786d03a68d6.svg";
export { ForwardRef as ReactComponent };